import { useWeekdayAbbreviation } from '~/common/utils/translate';
import { workdayColor, blackFont } from './colorConfig';
import { useTimetrackingStore } from './utils';
import { Th } from '@chakra-ui/react';

interface DayHeaderProps {
  day: Date;
}
export const DayHeader = ({ day }: DayHeaderProps) => {
  const { selectColumn } = useTimetrackingStore();

  const getWeekdayAbbreviation = useWeekdayAbbreviation();

  return (
    <Th
      onClick={(e) => {
        selectColumn(day, e.ctrlKey, e.shiftKey);
      }}
      backgroundColor={workdayColor}
      color={blackFont}
      userSelect="none"
      padding={0}
      cursor="pointer"
    >
      {getWeekdayAbbreviation(day)}
    </Th>
  );
};
